import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

export const ADDING_ADDRESSDB = () => ({ type: 'ADDING_ADDRESSDB', });
export const ADDING_ADDRESSDB_SUCCESS = () => ({ type: 'ADDING_ADDRESSDB_SUCCESS', });
export const ADDING_ADDRESSDB_ERROR = () => ({ type: 'ADDING_ADDRESSDB_ERROR', });

export const UPDATING_ADDRESSDB = () => ({ type: 'UPDATING_ADDRESSDB', });
export const UPDATING_ADDRESSDB_SUCCESS = () => ({ type: 'UPDATING_ADDRESSDB_SUCCESS', });
export const UPDATING_ADDRESSDB_ERROR = () => ({ type: 'UPDATING_ADDRESSDB_ERROR', });

export const LOADING_ADDRESSDBS = () => ({ type: 'LOADING_ADDRESSDBS', });
export const LOADING_ADDRESSDBS_SUCCESS = () => ({ type: 'LOADING_ADDRESSDBS_SUCCESS', });
export const LOADING_ADDRESSDBS_ERROR = () => ({ type: 'LOADING_ADDRESSDBS_ERROR', });

export const DELETING_ADDRESSDB = () => ({ type: 'DELETING_ADDRESSDB', });
export const DELETING_ADDRESSDB_SUCCESS = () => ({ type: 'DELETING_ADDRESSDB_SUCCESS', });
export const DELETING_ADDRESSDB_ERROR = () => ({ type: 'DELETING_ADDRESSDB_ERROR', });

//export const UPDATING_ADDRESSDB_CHECKS = () => ({ type: 'UPDATING_ADDRESSDB_CHECKS', });


export const getAddressDBs = (dispatch) => {
  dispatch({ type: LOADING_ADDRESSDBS });

  axios
    .get(`${serverURI}/api/advertise/addressdb/all`)
    .then((res) => {
      dispatch({
        type: LOADING_ADDRESSDBS_SUCCESS,
        payload: res.data.addressdbs
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_ADDRESSDBS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addAddressDB = (addressdb, dispatch) => {
  dispatch({ type: ADDING_ADDRESSDB });

  const addressdbData = new FormData();
  addressdbData.append('name', addressdb.name);
  addressdbData.append('file', addressdb.file);
  addressdbData.append('meter_type', addressdb.meter_type);
  addressdbData.append('modified_user', addressdb.modified_user);
  addressdbData.append('modified_at', addressdb.modified_at);
  addressdbData.append('description', addressdb.description);

  axios
    .post(`${serverURI}/api/advertise/addressdb/add`, addressdbData)
    .then((res) => {
      dispatch({ type: ADDING_ADDRESSDB_SUCCESS, 
        payload: res.data.addressdb, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_ADDRESSDB_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateAddressDB = (id, addressdb, dispatch) => {
  dispatch({ type: UPDATING_ADDRESSDB });

  const addressdbData = new FormData();
  addressdbData.append('name', addressdb.name);
  addressdbData.append('file', addressdb.file);
  addressdbData.append('prev_file', addressdb.prev_file);
  addressdbData.append('modified_user', addressdb.modified_user);
  addressdbData.append('modified_at', addressdb.modified_at);
  addressdbData.append('description', addressdb.description);

  axios
    .put(`${serverURI}/api/advertise/addressdb/update/${id}`, addressdbData)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_ADDRESSDB_SUCCESS, 
        payload: res.data.updated_addressdb, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_ADDRESSDB_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteAddressDB = (id, dispatch) => {
  dispatch({ type: DELETING_ADDRESSDB });

  return axios
    .delete(`${serverURI}/api/advertise/addressdb/delete/${id}`)
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_ADDRESSDB_SUCCESS, 
        payload: res.data.removed_addressdb, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_ADDRESSDB_ERROR, payload: err });
      errorHandler(err);
    });
};
